import { useEffect, useRef } from 'react';

export const useOriginalEffects = (muted, volume) => {
  const audio = useRef(null), voices = useRef(new Set()), current = useRef(null);
  current.current = { muted, level: Number.isFinite(Number(volume)) ? Math.min(100, Math.max(0, Number(volume))) / 100 : 0 };
  const prepare = () => {
    if (current.current.muted || !current.current.level) return null;
    try {
      const Audio = window.AudioContext || window.webkitAudioContext;
      if (!Audio) return null;
      const context = audio.current || (audio.current = new Audio());
      context.resume().catch(() => {}); return context;
    } catch { return null; }
  };
  const play = (kind) => {
    const context = prepare();
    if (!context) return;
    const now = context.currentTime, level = current.current.level;
    const attach = (source, nodes, when, duration) => {
      voices.current.add(source);
      source.onended = () => { voices.current.delete(source); source.disconnect(); nodes.forEach((node) => node.disconnect()); };
      source.start(when); source.stop(when + duration);
    };
    const tone = (frequency, end, when, duration, loudness, type = 'sine') => {
      const source = context.createOscillator(), gain = context.createGain(); source.type = type;
      source.frequency.setValueAtTime(frequency, when); source.frequency.exponentialRampToValueAtTime(end, when + duration * .85);
      gain.gain.setValueAtTime(.0001, when); gain.gain.linearRampToValueAtTime(loudness * level, when + .004); gain.gain.exponentialRampToValueAtTime(.0001, when + duration);
      source.connect(gain); gain.connect(context.destination); attach(source, [gain], when, duration + .005);
    };
    if (kind === 'rise') {
      for (let i = 0; i < 11; i += 1) tone(360 + i * 48, 370 + i * 49, now + i * .073, .072, .023, 'sine');
    } else if (kind === 'place') {
      tone(260, 110, now, .085, .075, 'triangle'); tone(1450, 800, now + .025, .035, .012);
    } else if (kind === 'card' || kind === 'bomb') {
      const duration = kind === 'card' ? .052 : .34;
      const buffer = context.createBuffer(1, Math.floor(context.sampleRate * duration), context.sampleRate), samples = buffer.getChannelData(0);
      for (let i = 0; i < samples.length; i += 1) samples[i] = (Math.random() * 2 - 1) * (1 - i / samples.length) ** 2;
      const source = context.createBufferSource(), filter = context.createBiquadFilter(), gain = context.createGain(); source.buffer = buffer;
      filter.type = kind === 'card' ? 'bandpass' : 'lowpass'; filter.frequency.setValueAtTime(kind === 'card' ? 1800 : 1700, now); filter.frequency.exponentialRampToValueAtTime(kind === 'card' ? 950 : 90, now + duration * .9); filter.Q.value = .5;
      gain.gain.setValueAtTime(kind === 'card' ? .0001 : .22 * level, now);
      if (kind === 'card') gain.gain.linearRampToValueAtTime(.075 * level, now + .006);
      gain.gain.exponentialRampToValueAtTime(.0001, now + duration);
      source.connect(filter); filter.connect(gain); gain.connect(context.destination); attach(source, [filter, gain], now, duration);
      if (kind === 'bomb') tone(120, 38, now, .27, .09);
      if (kind === 'card') tone(900, 550, now + .032, .018, .015, 'triangle');
    }
  };
  useEffect(() => { if (muted || Number(volume) === 0) { voices.current.forEach((voice) => { try { voice.stop(); } catch { /* Already ended. */ } }); voices.current.clear(); } }, [muted, volume]);
  useEffect(() => () => { const context = audio.current; audio.current = null; context?.close().catch(() => {}); }, []);
  return { prepare, play };
};